import styled from '@emotion/native';
import React, { FC } from 'react';
import { View } from 'react-native';

import Text from '@components/1-atoms/Text';
import ListItem from '@components/2-molecules/ListItem';
import { LineItemType } from '.';

const Container = styled(ListItem)`
  width: 100%;
  max-width: ${({ theme }: any) => `${theme.contentWidth}px`};
`;

const Count = styled(Text)`
  background-color: #E5E5E5;
  border-radius: 6px;
  padding: 3px 6px;
  font-size: 12px;  /* Adjusted for readability */
`;

type Props = {
  currency: string;
  data: LineItemType;
  onPress?: (lineItem: LineItemType, index: number) => void;
};

const LineItem: FC<Props> = ({ currency, data, onPress, ...props }) => {
  
  const [lineItem, setLineItem] = React.useState<LineItemType>(data);
  React.useEffect(() => { setLineItem(data) }, [data]);
  
  const { name, quantity, total, index } = lineItem;
  const price = total / quantity;
  
  const Content = <Text ellipsis>{name}</Text>;
  const Right = <Text currency={currency}>{total}</Text>;
  const Sub = <Text><Count>{quantity}</Count> x <Text decimal /* currency={currency} */>{price}</Text></Text>;
  
  return (
    <View>
      <Container
        sub={Sub}
        right={Right}
        onPress={ () => onPress?.(lineItem, index) }
      >
        {Content}
      </Container>
    </View>
  );
};

export default LineItem;
